import {createContext} from "react";

export const PaginationContext = createContext(null)